import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { API } from "@/App";
import { useAuth } from "@/context/AuthContext";
import { AuthShell, AuthAlert, PasswordField, validateNewPassword } from "@/components/AuthShell";

export default function SetPassword() {
  const { user, checkAuth, logout } = useAuth();
  const navigate = useNavigate();
  const firstTime = !!user?.must_change_password;
  const [current, setCurrent] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const v = validateNewPassword(password, confirm);
    if (v) return setError(v);
    setError("");
    setLoading(true);
    try {
      const res = await fetch(`${API}/auth/org/change-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ current_password: current, new_password: password }),
      });
      const data = await res.json();
      if (!res.ok) return setError(data.detail || "Could not change password");
      toast.success("Password updated");
      await checkAuth();
      navigate("/analytics", { replace: true });
    } catch {
      setError("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell subtitle={firstTime ? "Welcome! Choose your own password" : "Change your password"}>
      {firstTime && !error && (
        <AuthAlert type="success" testId="set-password-welcome">
          Signed in with your temporary password. Please set a new password to continue.
        </AuthAlert>
      )}
      {error && <AuthAlert testId="set-password-error">{error}</AuthAlert>}
      <form onSubmit={submit} className="space-y-4">
        <PasswordField label={firstTime ? "Temporary password (from your email)" : "Current password"} value={current} onChange={setCurrent} placeholder="Enter current password" testId="set-current-password" autoComplete="current-password" />
        <PasswordField label="New password" value={password} onChange={setPassword} placeholder="At least 8 characters" testId="set-new-password" autoComplete="new-password" />
        <PasswordField label="Confirm new password" value={confirm} onChange={setConfirm} placeholder="Re-enter password" testId="set-confirm-password" autoComplete="new-password" />
        <Button type="submit" disabled={loading} data-testid="set-password-submit-btn" className="w-full h-12 bg-[#006994] hover:bg-[#005577] text-white rounded-xl">
          {loading ? "Saving..." : "Save Password"}
        </Button>
      </form>
      <div className="text-center mt-4">
        {firstTime ? (
          <button onClick={logout} className="text-sm text-slate-500 hover:underline" data-testid="set-password-signout">Sign out</button>
        ) : (
          <button onClick={() => navigate(-1)} className="text-sm text-[#006994] hover:underline" data-testid="set-password-cancel">Cancel</button>
        )}
      </div>
    </AuthShell>
  );
}
